import React from 'react';

export default function ErrorPage() {
  return (
    <div>
      <h2 className="errorpage-header">404 error: Page Not Found!</h2>
    </div>
  )
}